import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config";
import { userHasAllRights } from "../../../functions/userRights.js";
import { setDocTitle } from "../../../functions/HelperFuncs";

export default {
  data() {
    return {
      id: this.$options.name,
      collections: [],
      doneSearching: false,
    };
  },

  created() {
    setDocTitle("Collections", this);

    //get files
    this.getCollections();

    EventBus.$on(`${this.id}-update`, () => {
      this.getCollections();
    });
  },
  methods: {
    getCollections() {
      this.doneSearching = false;
      this.collections = [];

      this.$axios.get(`${baseUrl}/collectionsall`).then((r) => {
        this.collections = r.data;

        this.doneSearching = true;
      });
    },
    transferSelected() {
      //got to the transfer
      this.$router.push(`/${this.$store.state.company}/mobile-transfer`);
    },
  },
  computed: {
    canAddCollection() {
      return !userHasAllRights(["collect"], this);
    },
    selectedTitle() {
      const selectedCollection = this.$store.state.transferItems.collection;

      return selectedCollection.name
        ? `${selectedCollection.name} selected`
        : "";
    },
  },
};
